module.exports = __webpack_public_path__ + "img/street-food.7a1a3189.webp";